import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionDetails, ListItem } from "@material-ui/core";
import Typing from "react-typing-animation";
import { ExpandLess } from "@material-ui/icons";
import PageFooter from "../../multi-page-attributes/PageFooter";

export default class PagesComponentRegular extends Component {
    render() {
        return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: "1%"
                }}>
                    <Link to={{ pathname: '/'}} style={{ color: "#007BFF",  backgroundColor: "#FFFFFF", // "#0F3057"
                        borderRadius: 10,  }}>
                        <ExpandLess style={{ height: 70, width: 70 }} />
                    </Link>
                </div>
                <Link to={{ pathname: '/terminal'}}
                      style={{ marginTop: "5%", marginLeft: 20, marginRight: 20,
                          color: "#000000", textDecoration: "none" }}>
                    <ListItem button style={{
                        textAlign: "center",
                        color: "black",
                        display: "block",
                        borderRadius: 30,
                        backgroundColor: "#FFFFFF"
                    }}>
                        <Accordion
                            defaultExpanded={true}
                            style={{ borderRadius: 30 }}
                        >
                            <AccordionDetails>
                                <div>
                                    <h2 style={{ color: "black", fontWeight: "bold", textDecoration: "underline",
                                        display: "flex", justifyContent: "center" }} >
                                        $&nbsp;
                                        <Typing speed={90} loop={true} >
                                        <span style={{
                                            color: "#007BFF"
                                        }}> whois</span> aniket
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={25} />
                                            <span style={{
                                                color: "#007BFF"
                                            }}> reveal</span> stack
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={25} />
                                        </Typing></h2>
                                    <h3 style={{ paddingTop: 20 }}>
                                        <b>Visit my <span style={{ color: "#007BFF", textDecoration: "underline" }}>
                                            terminal</span><span style={{ color: "#007BFF"}}>.</span></b></h3>
                                    <ul style={{ paddingTop: 10, textAlign: "left",
                                        color: "black" }}>
                                        <li style={{ paddingBottom: 15 }}>Use a simple, intuitive
                                            terminal to learn a little about me!<br /></li>
                                        <li style={{ paddingBottom: 15 }}>Not experienced with
                                            a terminal? No problem! Use my
                                            Terminal Walkthrough to get started.<br /></li>
                                        <li>This terminal supports
                                            commands for viewing my projects, hobbies,
                                            stack, and other cool stuff!</li>
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </ListItem>
                </Link>
                <Link to={{ pathname: '/about'}}
                      style={{ marginTop: 80, marginLeft: 20, marginRight: 20,
                          color: "#000000", textDecoration: "none" }}>
                    <ListItem button style={{
                        textAlign: "center",
                        color: "black",
                        display: "block",
                        borderRadius: 30,
                        backgroundColor: "#FFFFFF"
                    }}>
                        <Accordion
                            defaultExpanded={true}
                            style={{ borderRadius: 30 }}
                        >
                            <AccordionDetails>
                                <div>
                                    <h2 style={{ color: "black", fontWeight: "bold",
                                        textDecoration: "underline"}} >
                                        <Typing speed={90} loop={true} >
                                            About me.
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={20} />
                                            My jobs.
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={20} />
                                            My education.
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={20} />
                                            My projects.
                                            <Typing.Delay ms={1500} />
                                            <Typing.Backspace count={20} />
                                        </Typing>
                                    </h2>
                                    <h3 style={{ paddingTop: 20 }}>
                                        <b>Proceed to <span style={{ color: "#007BFF", textDecoration: "underline" }}>
                                            site</span><span style={{ color: "#007BFF"}}>.</span></b></h3>
                                    <ul style={{ paddingTop: 10, textAlign: "left",
                                        color: "black" }}>
                                        <li style={{ paddingBottom: 15 }}>For a simpler page about
                                            me, check out this link!<br /></li>
                                        <li style={{ paddingBottom: 15 }}>Here you can find an About
                                            Me, including my stack, work experience, and some of my projects.<br /></li>
                                        <li>This page mirrors any and all information accessible
                                            through my terminal in a terminal-like way.</li>
                                    </ul>
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </ListItem>
                </Link>
                <div style={{
                    position: "absolute",
                    bottom: 0,
                    padding: "1%"
                }}>
                    <PageFooter />
                </div>
            </div>
        );
    }
}
